import React, { useContext, useReducer } from 'react';
import { reducer, initialState, actions, store } from './reducer';
import { store as mainStore } from '../../../../../../store';
import Form from './Form';

const Drivers = () => {
  const { showMessage, showError } = useContext(mainStore);
  const { Provider } = store;
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Provider value={{ state, dispatch, actions }}>
      <Form />
    </Provider>
  );
};

export default React.memo(Drivers);
